import { Text } from '@/components/ui/text'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Box, Flex } from 'styled-system/jsx'
import { Actions } from '../Overview/actions/Actions'
import { AdminActions } from '../Overview/actions/AdminActions'
import { type SetupView, useSingle } from '../state'

export default function StickyBar() {
  const { activeView, setActiveView } = useService(useSingle)()

  const tab = (id: SetupView, label: string, badge?: string) => {
    const active = () => activeView() === id
    return (
      <Box
        as="button"
        onClick={() => setActiveView(id)}
        pos="relative"
        flex="1"
        textAlign="center"
        fontSize="14px"
        fontWeight="700"
        py="12px"
        cursor="pointer"
        display="inline-flex"
        alignItems="center"
        justifyContent="center"
        gap="7px"
        style={{ color: active() ? '#14161b' : '#8b909b' }}
        class={css({
          '&::after': active()
            ? {
              content: '""',
              position: 'absolute',
              left: '18%',
              right: '18%',
              bottom: '-1px',
              height: '3px',
              borderRadius: '3px 3px 0 0',
              bg: '#12b886',
            }
            : undefined,
        })}
      >
        {label}
        {badge && (
          <Text
            as="span"
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            minW="20px"
            h="20px"
            px="5px"
            fontSize="10.5px"
            fontWeight="700"
            color="#e5483d"
            borderRadius="6px"
            style={{ background: 'color-mix(in srgb, #e5483d 15%, #ffffff)' }}
          >
            {badge}
          </Text>
        )}
      </Box>
    )
  }

  return (
    <Box
      pos="sticky"
      top="56px"
      zIndex="25"
      bg="#fbfcfd"
      borderBottom="1px solid rgba(20, 22, 30, 0.09)"
      boxShadow="0 8px 18px -16px rgba(20, 22, 30, 0.4)"
      flexShrink={0}
    >
      <Box px="12px" pt="10px" pb="9px" display="grid" gridTemplateColumns="minmax(0, 1fr)" gap="7px">
        <Actions size="mobile" gap="7px" />
        <AdminActions size="mobileAdmin" />
      </Box>
      <Flex borderTop="1px solid rgba(20, 22, 30, 0.09)">
        {tab('analysis', 'Analysis')}
        {tab('discussion', 'Discussion')}
      </Flex>
    </Box>
  )
}
